<template>
  <span> 
    <span v-if="editor">
        <input placeholder="abcdefg" v-model="currentAlias">
        <sui-button content="Save" icon="save" positive @click="saveAlias()" size="mini" />    
        <sui-button content="" icon="close" @click="cancelEditor()" size="mini" />    
    </span>
    <span v-else @mouseover="mouseover = true" @mouseleave="mouseover = false">
        <router-link :to="'/channel/' + currentAlias" class="nav-link">{{ currentAlias }}</router-link> <span v-show="mouseover" @click="openEditor()"><i class="edit icon"></i></span>
    </span>
  </span>
</template>

<script>
import DziService from '@/DziService'

export default {
  name: 'AliasInlineEditor',
  data () {
        return {
            editor: false,
            mouseover: false,
            currentAlias: null
        }
    },  
props: {
    alias: {
      type: String,
      required: true
    },
    deviceId:  {
      type: String,
      required: true
    }
},
created() {
    this.currentAlias = this.alias;
    },
  methods: {
        openEditor() {
            this.aliasBeforeEdit = this.currentAlias;
            this.editor = true;
        },
        cancelEditor() {
            this.currentAlias = this.aliasBeforeEdit;
            this.editor = false;
        },
        async saveAlias () {

            
            const response = await DziService.update(this.deviceId, {'alias': this.currentAlias});
            
            if (typeof response.data.error !== 'undefined')
            {
                this.error = response.data.error;
            }
            else 
            {
                // event?
                this.editor = false;
            }
                
        },
    }
    
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
</style>
